import React from 'react'
import createReactClass from 'create-react-class'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import serviceLocator from 'live/services/service-locator'
import { encryptDidMount, handleEncryptSubmit } from 'live/components/forms/ui/UserTable/utils'

import EncryptForm from 'live/components/forms/ui/UserTable/EncryptForm'

const TYPE = 'pwda'

var ValidationMixin = require('live/components/forms/mixins/validation-mixin')
var ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        endpoint: '',
        event_limit: 1000,
        enableForOutput: true,
        timestamp_mode: 'adjusted',
        wells: [],
        users: {},
        anonymous: true
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
})

var Form = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    endpoint: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Output URL') + ' ' + i18n('must not be empty')
                    },
                    event_limit: {
                        required: true,
                        allowEmpty: false,
                        message: 'Event Limit ' + i18n('must not be empty')
                    }
                }
            }
        }
    },

    onChangeWell: function(wells) {
        var object = this.state.object
        var config = object.config

        config.wells = wells
        object.config = config
        this.applyObj({ config: config })
    },

    onChangeTimestampMode: function(event) {
        var object = this.state.object
        var config = object.config

        config.timestamp_mode = event.target.value
        this.setState(config)
    },

    onChangeUsers: function(value) {
        var object = this.state.object
        const users = {}

        _.map(value, (user, i) => {
            users[(user && user.username) || '_order' + i] = {
                password: (user && user.password) || '',
                order: i
            }
        })

        object.config.users = users
        this.applyObj(object)
    },

    componentDidMount() {
        serviceLocator.getService('liverig-wells-shared-components').then(wellsService => {
            var Rigs = wellsService.Rigs

            this.setState({ Rigs })
        })
        serviceLocator.getService('liverig-curves-shared-components').then(curvesService => {
            var Users = curvesService.Users
            var TimestampModes = curvesService.TimestampModes

            this.setState({ Users, TimestampModes })
        })

        encryptDidMount.bind(this)()
    },

    onChangeAnonymous: function(event) {
        var object = this.state.object

        object.config.anonymous = !event.target.checked

        this.setState(object)
    },

    _onSuccess: function() {
        window.location.href = '#/integrations/' + TYPE + '/' + this.state.object.id
    },
    _onDelete: function() {
        window.location.href = '#/integrations/'
    },

    render: function() {
        var uiCfg = {
            hideDivider: true
        }

        var object = this.state.object
        var config = object.config

        handleEncryptSubmit.bind(this)()
        const { TimestampModes, Rigs, Users } = this.state

        return (
            <EncryptForm self={this} uiCfg={uiCfg} test={false}>
                <div className={'export-form ' + TYPE}>
                    <div className="form-area">
                        <FormGroup
                            type="text"
                            label={i18n('Output URL')}
                            name="config.endpoint"
                            value={config.endpoint}
                            placeholder={'http://0.0.0.0:52535/liverig/' + TYPE}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.endpoint')}
                            hasFeedback
                            help={this.errorsFor('config.endpoint')}
                        />
                        {TimestampModes ? (
                            <TimestampModes config={config} onChange={this.onChangeTimestampMode} />
                        ) : null}

                        <FormGroup
                            type="number"
                            label="Event Limit"
                            className="event-limit"
                            name="config.event_limit"
                            value={parseInt(config.event_limit)}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.event_limit')}
                            hasFeedback
                            help={this.errorsFor('config.event_limit')}
                        />

                        {Users ? (
                            <Users
                                onChange={this.onChangeUsers}
                                onChangeAnonymous={this.onChangeAnonymous}
                                object={object}
                                initPassword={this.state?.original?.config?.users}
                                setEditing={this.state.setHasUnSavedPassword}
                            />
                        ) : null}
                    </div>
                    <hr />
                    {Rigs ? <Rigs onChange={this.onChangeWell} config={config} /> : null}
                </div>
            </EncryptForm>
        )
    }
})

module.exports = Form
